import React from 'react';

export default function DevProjectCard({ project }) {
  return (
    <div className="border-2 border-black p-6 bg-white shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] hover:translate-x-[-2px] hover:translate-y-[-2px] transition-all rounded-lg flex flex-col h-full">
      <h3 className="text-xl font-black mb-3">{project.title}</h3>
      <p className="text-base mb-4 leading-relaxed min-h-[120px]">{project.description}</p>
      
      <div className="mb-4 min-h-[88px]">
        <p className="font-bold text-sm mb-2">Tech Stack</p>
        <div className="flex flex-wrap gap-2">
          {project.tech.map((tech, i) => (
            <span key={i} className="px-3 py-1 bg-amber-200 border-2 border-black text-xs font-bold rounded-md">
              {tech}
            </span>
          ))}
        </div>
      </div>

      <div className="mb-6 min-h-[88px]">
        <p className="font-bold text-sm mb-2">Skills</p>
        <div className="flex flex-wrap gap-2">
          {project.skills.map((skill, i) => (
            <span key={i} className="px-3 py-1 bg-violet-200 border-2 border-black text-xs font-bold rounded-md">
              {skill}
            </span>
          ))}
        </div>
      </div>

      <a 
        href={project.github} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="inline-block px-5 py-2 bg-black text-white font-bold border-2 border-black hover:bg-neutral-800 transition-colors rounded-md mt-auto self-start"
      >
        View on GitHub
      </a>
    </div>
  );
}